'use client'

import { cn } from '@utils/cn'
import { type AuthTab } from '@view/auth/model'

interface AuthTabsProps {
  active: AuthTab
  onChange: (tab: AuthTab) => void
}

const tabs: { id: AuthTab; label: string }[] = [
  { id: 'login', label: 'Вход' },
  { id: 'register', label: 'Регистрация' },
]

export const AuthTabs = ({ active, onChange }: AuthTabsProps) => {
  return (
    <div role="tablist" className="grid grid-cols-2 gap-1 rounded-lg bg-gray-100 p-1 dark:bg-gray-700">
      {tabs.map((tab) => {
        const isActive = tab.id === active
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={cn(
              'rounded-md py-2.5 text-sm font-semibold transition-colors',
              isActive
                ? 'bg-white text-gray-900 shadow-sm dark:bg-gray-800 dark:text-white'
                : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
            )}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
